import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink
} from '@apollo/client';
import { DevGraphQl, ProductionGraphql } from '../serverLinks';
import { getCookie } from '../utils';
// `VITE_GRAPHQL` wins wherever it is set, INCLUDING in dev. Without this the
// dev branch used the hardcoded `DevGraphQl` and every local GraphQL call went
// to production regardless of your .env — so "running locally" quietly meant
// "reading prod". Prod builds always set the var, so their behaviour is
// unchanged; `DevGraphQl` remains the fallback when nothing is configured.
const API_URL = `${ProductionGraphql || DevGraphQl}/graphql`;
const httpLink = new HttpLink({ uri: API_URL });

const authMiddleware = new ApolloLink((operation, forward) => {
  const token = getCookie('rb_access_token');
  const authorization = token ? token : '';
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: authorization
    }
  }));

  return forward(operation);
});

const link = ApolloLink.from([authMiddleware, httpLink]);

const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache({ addTypename: false })
});

export default apolloClient;
